import(/* webpackMode: "eager" */ "/home/runner/work/landing/landing/src/app/page.tsx");
